import auth from "./auth";
import blends from "./blends";
import coffeecacao from "./coffeecacao";
import common from "./common";
import dashboard from "./dashboard";
import dds from "./dds";
import error from "./error";
import farm from "./farm";
import oma from "./oma";
import survey from "./survey";
import regionalRiskAssessment from './regionalRiskAssessment'
import indigenous from "./indigenous";
import settings from "./settings";
import marketplace from "./marketplace";
import report from "./report";

import carbonCredit from './carbonCredit'
import approvalFlow from './approval-flow'
import updatePassword from './update-password';
import guide from './guide';

export default {
  ...auth,
  ...coffeecacao,
  ...common,
  ...dashboard,
  ...dds,
  ...error,
  ...farm,
  ...oma,
  ...survey,
  ...blends,
  ...regionalRiskAssessment,
   ...indigenous,
   ...settings,
   ...marketplace,
   ...report,
  ...indigenous,
  ...carbonCredit,
  ...approvalFlow,
  ...updatePassword,
  ...guide,
};
